import { ComponentPropsWithRef } from "react";

export const MinimalPauseIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="3.9375" height="13.5" rx="0.5" fill="currentColor" />
    <rect
      x="6.5625"
      width="3.9375"
      height="13.5"
      rx="0.5"
      fill="currentColor"
    />
  </svg>
);
